import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { HardLoadingComponent } from "@hardcode-kz/ui";
import { AuthService } from "@app/core/auth";
import { UserRoleEnum } from "@models/user-management/user-role";

@Component({
  selector: "app-routing",
  standalone: true,
  template: "<hard-loading class='absolute'></hard-loading>",
  imports: [HardLoadingComponent],
})
export class RoutingComponent {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {
    // Определяем стратегию → получаем/сохраняем токен → получаем пользователя → навигация
    this.authService.updateCurrentUser().then((user) => {
      if (user) {
        const isAdmin = user.roleNames?.includes(UserRoleEnum.Admin);
        const homePageUrl = isAdmin
          ? "/admin"
          : user.homePageMenuItemUrl || "/my-requests";
        this.router.navigate([homePageUrl], { replaceUrl: true });
      } else {
        this.router.navigate(["/auth"], { replaceUrl: true });
      }
    });
  }
}
